import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoforttourcab() {



  const cardData = {
"keyword": "Pune to Fort Tour Cab (Sinhagad Rajgad Torna Lohagad)",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Fort Tour Cab for travelers who want to explore the iconic Sahyadri forts in a safe, convenient, and well-planned way. Whether you are planning a one-day adventure, trekking trip, history tour, family outing, photography tour, or weekend escape, our cab service ensures a smooth and stress-free journey. With experienced drivers who are familiar with ghat roads and fort routes, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, trekking groups, families, and adventure enthusiasts. With flexible custom itineraries, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and memorable fort exploration experience across Maharashtra’s most historic destinations.",

"topPlaces": [
  {
    "title": "Sinhagad Fort",
    "description":
      "Sinhagad Fort is one of the most popular forts near Pune known for its historic Maratha battles, trekking trails, and panoramic views of the Sahyadri ranges. It is a must-visit destination for adventure lovers, history enthusiasts, and weekend trekkers traveling from Pune."
  },
  {
    "title": "Rajgad Fort",
    "description":
      "Rajgad Fort is a majestic hill fort that served as the capital of the Maratha Empire for many years. Known for its massive structure, scenic trekking routes, and historical significance, it offers one of the most rewarding fort experiences near Pune."
  },
  {
    "title": "Torna Fort",
    "description":
      "Torna Fort, also known as Prachandagad, is the first fort captured by Chhatrapati Shivaji Maharaj. It is famous for its challenging trekking routes, rugged terrain, and breathtaking views from the top, making it a favorite for experienced trekkers."
  },
  {
    "title": "Lohagad Fort",
    "description":
      "Lohagad Fort is a well-preserved hill fort known for its easy trekking trail, iconic Vinchu Kata (scorpion tail structure), and beautiful monsoon scenery. It is ideal for beginners, families, and nature lovers."
  },
  {
    "title": "Visapur Fort",
    "description":
      "Visapur Fort is located near Lohagad and is known for its larger structure, dense greenery, and waterfall trails during monsoon. It offers a more adventurous trekking experience compared to Lohagad."
  },
  {
    "title": "Tikona Fort",
    "description":
      "Tikona Fort is a pyramidal-shaped hill fort known for its short but steep trek, ancient caves, and stunning views of Pavana Lake and surrounding valleys."
  },
  {
    "title": "Pawna Lake",
    "description":
      "Pawna Lake is a scenic lake located near Lohagad and Tikona forts, popular for camping, photography, and sunset views. It is a perfect relaxation spot after fort exploration."
  },
  {
    "title": "Malhargad Fort",
    "description":
      "Malhargad Fort is one of the lesser-known forts near Pune offering peaceful trekking routes, historical remains, and panoramic views of surrounding villages and hills."
  },
  {
    "title": "Rajmachi Fort Region",
    "description":
      "Rajmachi Fort is a popular trekking destination located between Lonavala and Karjat, known for its twin forts Shrivardhan and Manaranjan, lush greenery, and monsoon beauty."
  },
  {
    "title": "Sahyadri Mountain Scenic Route",
    "description":
      "The Pune fort tour route passes through the beautiful Sahyadri mountain ranges, ghat roads, dense forests, waterfalls during monsoon, and scenic viewpoints, making the journey itself an unforgettable part of the adventure."
  }
],



services: [
  {
    name: "Pune Fort Tour Cab",
    description: "Pune fort tour cab service provides reliable transportation for travelers exploring famous forts and historical attractions around Pune. Comfortable vehicles with experienced drivers ensure smooth travel for families, tourists, trekkers, and history enthusiasts. Pickup services are available from homes, hotels, railway stations, airport terminals, and offices across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient fort tour cab reservations."
  },
  {
    name: "Pune Fort Sightseeing Taxi",
    description: "Pune fort sightseeing taxi service offers dependable transportation for sightseeing tours to popular forts around Pune with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for tourism, heritage visits, trekking trips, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient sightseeing taxi reservations."
  },
  {
    name: "Pune Fort Trip Cab Service",
    description: "Pune fort trip cab service provides comfortable transportation for passengers visiting famous hill forts, trekking destinations, and historical landmarks near Pune. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys through scenic routes. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for one-day fort trips and weekend tourism requirements. Flexible booking options allow convenient fort trip cab reservations."
  },
  {
    name: "Sinhagad Rajgad Torna Lohagad Cab",
    description: "Sinhagad Rajgad Torna Lohagad cab service offers reliable transportation with comfortable vehicles and professional drivers for visiting the famous forts near Pune. Vehicles provide smooth highway and ghat travel suitable for tourism, trekking, sightseeing, and adventure outings. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy fort circuit cab reservations."
  },
  {
    name: "Pune Fort Circuit Taxi",
    description: "Pune fort circuit taxi service provides dependable transportation solutions for passengers traveling across multiple forts and heritage attractions around Pune. Vehicles are suitable for city, highway, and hill route travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for fort tourism, heritage tours, and sightseeing trips. Flexible booking options allow convenient fort circuit taxi reservations."
  },
  {
    name: "Pune Heritage Fort Cab",
    description: "Pune heritage fort cab service provides transparent and reliable transportation for travelers exploring historical forts and cultural landmarks near Pune. Travelers can enjoy comfortable journeys with experienced drivers familiar with popular fort routes and heritage destinations. Comfortable vehicles ensure smooth travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient heritage fort cab reservations."
  },
  {
    name: "Pune Hill Fort Tour Cab",
    description: "Pune hill fort tour cab service provides economical and comfortable transportation for travelers planning sightseeing tours to hill forts and trekking spots around Pune. Comfortable vehicles ensure smooth highway and ghat travel suitable for tourism, trekking, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient hill fort tour cab reservations."
  },
  {
    name: "Pune Trekking Spots Cab",
    description: "Pune trekking spots cab service offers convenient transportation for passengers planning trekking trips and adventure tours around Pune. Comfortable vehicles provide smooth travel with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for trekking groups, adventure tourism, and weekend travel. Flexible booking options allow convenient trekking cab reservations."
  },
  {
    name: "Best Pune Fort Tour Taxi",
    description: "Best Pune fort tour taxi service allows passengers to reserve comfortable transportation for exploring multiple forts and historical attractions near Pune. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the fort tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow premium fort tour taxi reservations."
  },
  {
    name: "Cheap Pune Fort Cab",
    description: "Cheap Pune fort cab service provides affordable transportation for travelers planning fort sightseeing and trekking trips around Pune. Vehicles ensure reliable highway and hill route travel suitable for heritage tourism, trekking, and family outings. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow economical fort cab reservations."
  },
  {
    name: "SUV Pune Fort Tour Cab",
    description: "SUV Pune fort tour cab service provides spacious transportation for families and groups traveling around Pune for fort sightseeing and trekking trips. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for hill fort journeys and adventure outings. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV fort cab reservations."
  },
  {
    name: "Innova Pune Fort Circuit Cab",
    description: "Innova Pune fort circuit cab service provides premium SUV transportation for passengers seeking comfortable and reliable travel to Pune’s famous forts and trekking destinations. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, trekking, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova fort cab reservations."
  },
  {
    name: "Sedan Pune Fort Taxi",
    description: "Sedan Pune fort taxi service offers economical and comfortable transportation for solo travelers, couples, and small families visiting forts and sightseeing destinations around Pune. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for local sightseeing journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan fort taxi reservations."
  },
  {
    name: "Pune Historical Fort Cab",
    description: "Pune historical fort cab service offers dependable transportation for passengers exploring Pune’s historical forts, heritage landmarks, and cultural attractions. Comfortable vehicles ensure smooth highway and hill route travel suitable for tourism, educational tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient historical fort cab reservations."
  },
  {
    name: "Pune Adventure Tour Cab",
    description: "Pune adventure tour cab service provides reliable transportation for travelers planning adventure trips, trekking tours, and outdoor sightseeing around Pune. Comfortable vehicles ensure smooth and safe travel suitable for tourists, trekkers, families, and adventure enthusiasts. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient adventure tour cab reservations."
  }
],

tableData: [
  ["Pune Fort Tour Cab", "Pune Fort Sightseeing Taxi"],
  ["Pune Fort Trip Cab Service", "Sinhagad Rajgad Torna Lohagad Cab"],
  ["Pune Fort Circuit Taxi", "Pune Heritage Fort Cab"],
  ["Pune Hill Fort Tour Cab", "Pune Trekking Spots Cab"],
  ["Best Pune Fort Tour Taxi", "Cheap Pune Fort Cab"],
  ["SUV Pune Fort Tour Cab", "Innova Pune Fort Circuit Cab"],
  ["Sedan Pune Fort Taxi", "Pune Historical Fort Cab"],
  ["Pune Adventure Tour Cab", "Pune Fort Tour Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Fort Tour Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Fort Tour cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe fort sightseeing travel."
      },
      {
        WhyChooseheading: "Affordable Fort Tour Taxi Packages",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Fort Tour cab pricing with transparent fare details and no hidden charges. Customers receive complete tour package information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Fort Tour Cab Availability",
        WhyChoosedescription: "Our Pune Fort Tour cab service operates 24 hours a day for trekking trips, sightseeing tours, family outings, history tours, and weekend travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences during fort tours."
      },
      {
        WhyChooseheading: "Customized Fort Sightseeing Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including Sinhagad Fort tours, Rajgad trekking trips, Torna Fort visits, Lohagad sightseeing, and customized fort travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for trekkers, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Fort Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune fort routes and hill roads, ensuring safe driving, smooth travel, and timely arrival for every fort tour journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune Fort Tour cab service?", answer: "Pune Fort Tour cab service provides comfortable taxi transportation for visiting famous forts like Sinhagad, Rajgad, Torna, and Lohagad." },
    { question: "Is Pune Fort Tour cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune Fort Tour cab service." },
    { question: "Which vehicles are available for fort tours?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book customized fort tour packages?", answer: "Yes, customers can book customized fort sightseeing and trekking tour packages according to their requirements." },
    { question: "Which forts are covered in the Pune Fort Tour package?", answer: "Shivai Travels covers Sinhagad Fort, Rajgad Fort, Torna Fort, Lohagad Fort, and other nearby historical forts." },
    { question: "Are all fort tour taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune Fort Tour cab service online?", answer: "Yes, customers can easily book Pune Fort Tour cab service online or through phone booking." },
    { question: "Do you provide cabs for trekking groups and family tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for trekking groups, family tours, and sightseeing travel." },
    { question: "Are Pune Fort Tour cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune Fort Tour cab service?", answer: "Yes, advance booking is available and recommended during weekends, monsoon seasons, and holidays." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Sagar Patil",
      feedback:
        "Booked Pune Fort Tour cab service with Shivai Travels. Comfortable vehicle, smooth fort travel, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Pune Fort Tour taxi service. Affordable pricing, clean cab, and wonderful trekking tour experience.",
      rating: 5
    }
  ];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Fort Tour Cab Service (Sinhagad, Rajgad, Torna, Lohagad)",
  "image": "https://shivaitravels.com/assets/images/pune-fort-tour-cab.jpg",
  "description": "Book Pune Fort Tour cab service for comfortable sightseeing and heritage travel. Shivai Travels offers customized fort circuit trips covering Sinhagad, Rajgad, Torna, and Lohagad forts with sedan, SUV, Innova, and luxury cab options available 24x7 for adventure and historical tours.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-fort-tour-cab"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune Fort Tour Cab | Sinhagad Rajgad Torna Lohagad Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune Fort Tour cab service for Sinhagad, Rajgad, Torna, and Lohagad forts. Affordable sightseeing packages with sedan, SUV, Innova, and luxury cabs available 24x7 for heritage tours, trekking spots, and adventure travel."
  />

  <meta
    name="keywords"
    content="pune fort tour cab, pune fort sightseeing taxi, pune fort trip cab service, sinhagad rajgad torna lohagad cab, pune fort circuit taxi, pune heritage fort cab, pune hill fort tour cab, pune trekking spots cab, best pune fort tour taxi, cheap pune fort cab, suv pune fort tour cab, innova pune fort circuit cab, sedan pune fort taxi, pune historical fort cab, pune adventure tour cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoforttourcab;